export default __webpack_public_path__ + "static/careers-and-much-more-689adf6eda6892785963f875666444c6.svg";